import React from "react";
import OrganizationWorkflowsWrapper from "./OrganizationWorkflowsWrapper";

type Props = {
    id: string;
};

const OrganizationWorkflows: React.FC<Props> = ({ id }) => {
    return (
            <OrganizationWorkflowsWrapper orgId={id} />
    );
};

export default OrganizationWorkflows;
